import React from 'react';
import { FlexGrid2, TypographyBody, Styler, BellIcon, Notification2 } from '@honeycomb/ui-core';
import { useGlobalContext, TripType } from '@honeycomb/data';
import { SearchAlternativeDatesButton } from '../HotelSearchNoResult/SearchAlternativeDatesButton';
import { LookForHotelOnlyButton } from '../HotelSearchNoResult/LookForHotelOnlyButton';
export function StopSellMessageBlock({ state, actions }) {
    const { resourceStrings: { NOTAVL, NOHOTELDESC }, } = useGlobalContext();
    const { showFullSearch } = actions;
    const { stackButtons = false } = state;
    return (React.createElement("div", null,
        React.createElement(Styler, { mb: 4 },
            React.createElement(Notification2, { color: "highlight", icon: React.createElement(BellIcon, null) },
                React.createElement(FlexGrid2, { container: true, flexWrap: "nowrap", alignItems: "flex-start", spacing: 4 },
                    React.createElement(FlexGrid2, null,
                        React.createElement(TypographyBody, { weight: "bold", "data-id": "no-matches-heading" }, state.stopSellMessage.title || NOTAVL),
                        React.createElement("p", { "data-id": "no-matches-message" }, state.stopSellMessage.message || NOHOTELDESC))))),
        React.createElement(FlexGrid2, { container: true, spacing: 3 },
            React.createElement(FlexGrid2, { xs: 12, m: stackButtons ? 12 : 'auto' },
                React.createElement(SearchAlternativeDatesButton, { showFullSearch: showFullSearch, fullWidth: true })),
            state.tripType === TripType.Holiday && (React.createElement(FlexGrid2, { xs: 12, m: stackButtons ? 12 : 'auto' },
                React.createElement(LookForHotelOnlyButton, { fullWidth: true }))))));
}
